import ApiService from '@/core/services/ApiService';
import { Actions, Mutations } from '@/store/enums/StoreEnums';
import { Module, Action, Mutation, VuexModule } from 'vuex-module-decorators';

export interface Property {
  id: number;
  propertyId: number;
  block: number;
  plot: number;
  paciNo: number;
  street: string;
  houseNo: number;
  paidPercentage: number;
  salePercentage: any;
  longitude: number;
  latitude: number;
  size: number;
  startingPrice: number;
  startingPricePerSqrM: number;
  statusId: number | null;
  salePrice: number;
  salePricePerSqrM: number;
  percentagePremiumPaid: number;
  isActive: boolean;
  additionalInfoEn: string;
  additionalInfoAr: string;
  createdAt: string;
  areaName: number | null;
  auctionsLocation: any;
  propertyDescription: any;
}

export interface AuctionPropertiesFilterListInfo {
  dateFrom: string;
  dateTo: string;
  areaId: undefined | string | '';
  size: undefined | string | '';
  startingPrice: undefined | string;
  salePrice: undefined | string;
  propertyTypeId: undefined | string | '';
  statusId: undefined | string | '';
  descriptionId: undefined | string | '';
  block: undefined | string | '';
  plot: undefined | string | '';
}

export interface AuctionsPropertiesListInfo {
  totalItems: number;
  currentPage: number;
  pageSize: number;
  isNext: boolean;
  previous: number;
  properties: Array<Property>;
  errors: unknown;
}

@Module
export default class AuctionsPropertiesModule
  extends VuexModule
  implements AuctionsPropertiesListInfo
{
  properties = [] as Array<Property>;
  propertiesFilter = {} as AuctionPropertiesFilterListInfo;
  totalItems = 0;
  currentPage = 1;
  pageSize = 10;
  previous = 0;
  isNext = true;
  errors = {};

  get auctionsPropertiesList(): Array<Property> {
    return this.properties;
  }

  get auctionsPropertiesListCount(): number {
    return this.totalItems;
  }

  get auctionPropertiesPageSize(): number {
    return this.pageSize;
  }

  @Mutation
  [Mutations.SET_AUCTION_PROPERTIES_LIST](data) {
    this.properties = data.data;
    this.totalItems = data.totalItems;
    this.currentPage = data.currentPage;
    this.pageSize = data.pageSize;
    this.isNext = data.isNext;
    this.previous = data.previous;
    this.errors = {};
  }

  @Mutation
  [Mutations.RESET_AUCTIONS_PROPERTIES_LIST]() {
    this.properties = [] as Array<Property>;
    this.totalItems = 0;
    this.currentPage = 1;
    this.pageSize = 10;
    this.previous = 0;
    this.isNext = true;
    this.errors = {};
  }

  @Mutation
  [Mutations.SET_AUCTION_PROPERTY_CURRENT_PAGE](page) {
    this.currentPage = page;
  }

  @Mutation
  [Mutations.SET_AUCTION_PROPERTIES_FILTER](obj) {
    console.log(obj);
    this.propertiesFilter.dateFrom = String(obj.dateFrom);
    this.propertiesFilter.dateTo = String(obj.dateTo);
    this.propertiesFilter.areaId = String(obj.areaId);
    this.propertiesFilter.propertyTypeId = String(obj.propertyTypeId);
    this.propertiesFilter.size = String(obj.size);
    this.propertiesFilter.startingPrice = String(obj.startingPrice);
    this.propertiesFilter.salePrice = String(obj.salePrice);
    this.propertiesFilter.statusId = String(obj.statusId);
    this.propertiesFilter.descriptionId = String(obj.descriptionId);
    this.propertiesFilter.block = String(obj.block);
    this.propertiesFilter.plot = String(obj.plot);
  }

  @Action
  [Actions.UPDATE_AUCTION_PROPERTY_CURRENT_PAGE](val) {
    this.context.commit(Mutations.SET_AUCTION_PROPERTY_CURRENT_PAGE, val);
  }

  @Action
  [Actions.UPDATE_AUCTION_PROPERTIES_FILTER](val) {
    this.context.commit(Mutations.SET_AUCTION_PROPERTIES_FILTER, val);
  }

  @Action
  [Actions.GET_PROPERTY_DETAILS](id) {
    ApiService.setAuthorizationHeader();
    return ApiService.get('/auctions-properties', id);
  }

  @Action
  [Actions.GET_AUCTION_PROPERTIES_LISTING]() {
    ApiService.setAuthorizationHeader();
    const params = {
      page: this.currentPage,
      dateFrom: this.propertiesFilter.dateFrom,
      dateTo: this.propertiesFilter.dateTo,
      areaId: this.propertiesFilter.areaId,
      startingPrice: this.propertiesFilter.startingPrice,
      salePrice: this.propertiesFilter.salePrice,
      propertyTypeId: this.propertiesFilter.propertyTypeId,
      size: this.propertiesFilter.size,
      statusId: this.propertiesFilter.statusId,
      descriptionId: this.propertiesFilter.descriptionId,
      block: this.propertiesFilter.block,
      plot: this.propertiesFilter.plot,
    };
    return ApiService.query('/auctions-properties', {
      params,
    })
      .then(({ data }) => {
        this.context.commit(Mutations.SET_AUCTION_PROPERTIES_LIST, data);
      })
      .catch(({ response }) => {
        console.error('API Error:', response);
      });
  }
}
